module.exports = __webpack_public_path__ + "static/media/atrium-6.ef6488b4.jpg";